import { useQuery, queryOptions } from "@tanstack/react-query";
import { apiClient, signApiRequest } from "./";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";

export const getTransferPolicy = async ({
  credentials,
}: {
  credentials: CustomerCredentials;
}) => {
  const signedRequest = await signApiRequest(
    "GET",
    `${import.meta.env.VITE_API_URL}/transfer/transfer-status?fid=${credentials.identityId}`,
    credentials,
    { "content-type": "application/json" },
  );

  const response = await apiClient(signedRequest);
  return response.data;
};

export const getTransferPolicyQueryOptions = (
  credentials: CustomerCredentials,
) =>
  queryOptions({
    queryKey: ["get-transfer-policy"],
    queryFn: () => getTransferPolicy({ credentials }),
    retry: false,
    staleTime: 30_000,
    throwOnError: (error) => {
      captureException(error, {
        tags: {
          operation: "get-transfer-policy",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/transfer/transfer-status?fid=${identityId}",
        },
        level: "error",
      });
      return true;
    },
  });

export const useGetTransferPolicy = ({
  credentials,
  enabled = true,
}: {
  credentials: CustomerCredentials;
  enabled?: boolean;
}) => {
  const transferPolicyQuery = useQuery({
    queryKey: ["get-transfer-policy"],
    queryFn: () => getTransferPolicy({ credentials }),
    enabled,
    staleTime: 2000,
    gcTime: 60000,
    throwOnError: (error) => {
      captureException(error, {
        tags: {
          operation: "get-transfer-policy",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/transfer/transfer-status?fid=${identityId}",
        },
        level: "error",
      });
      return true;
    },
  });
  return transferPolicyQuery;
};
